export default {
  authApis: {
    signupInitialDataSave: "auth/intial-signup",
    signupValidateOtp: "auth/signup-verify-otp",
    signupresendOtp: "auth/signup-resend-otp",
    login: "auth/login",
    getUserDetails: "auth/get-user-details",
    verifyContact: "auth/verify-contact",
    verifyOtp: "auth/login-verify-otp",
    resendOtp: "auth/login-resend-otp",
    createMpin: "auth/create-mpin",
    verifyMpin: "auth/verify-mpin",
    kycDetail: "auth/kyc-details",
    forgotMpin: "auth/forgot-mpin",
    forgotMpinVerifyOTP: "auth/forgot-mpin-verify-otp",
    unlockAccount: "auth/unlock-account",
    unlockAccountOtp: "auth/validate-unlock-account-otp",
    refreshToken: "profile/refresh-token",
    androidIntegrity: "auth/verify-integrity",
    authKRA: "auth/kra-generateUrl",
    mockAPi: "auth/mock-deeplink",
    unclaimed: "corporate/unclaimed-division",
  },
  profileApis: {
    verifyMpin: "profile/verify-mpin",
    updateMpin: "profile/update-mpin",
    sendOtp: "profile/send-otp",
    verifyOtp: "profile/verify-otp",
    resendOtp: "profile/resend-otp",
    refreshToken: "profile/refresh-token",
    getBanners: "profile/banners",
    appSettings: "profile/app-settings",
  },
  fundDetails: {
    getFundList: "read-apis/fund-master-V2",
    getLatestFactSheet: "fund-details/getLatestFactSheet",
    getFundPresentationByPlan: "fund-details/getFundPresentationByPlan",
    getAllForms: "fund-details/getAllForms",
    getGraphByPlanName: "fund-details/getGraphByPlanName",
  },
  fundManagement: {
    getFundsManagedByTitle: "fund-details/getFundsManagedByTitle",
    getFundDashboard: "fund-details/fund-dashboard",
    getPortFolioByPlan: "fund-details/getPortFolioByPlan",
    getPlanOverviewBySchemeCode: "fund-details/getPlanOverviewBySchemeCode",
    getAllMarketInsightVideo: "fund-details/getAllMarketInsightVideo",
    getAllInsightArticle: "fund-details/getAllInsightArticle",
    getAllPlanDetails: "fund-details/getAllPlanDetails",
    getAllSchemeSIPValue: "fund-details/getSchemeSIPValue",
  },

  bankDetails: {
    getBankList: "read-apis/payout-details",
  },
  folio: {
    getFolios: "read-apis/discover-folio",
  },
  createNewFolio: {
    getPinCodeDetails: "read-apis/pincode-details",
    getOccupation: "read-apis/occupation-master",
    getIncomeSlab: "read-apis/income-slab-master",
    getNomineeRelationship: "read-apis/nominee-relation",
    getRelation: "read-apis/family-flag",
    getCategoryDetails: "read-apis/category-details",
    uploadCheque: "cloud-transaction/upload-cheque",
    verifyBankDetails: "cloud-transaction/verify-bank-details",
    getIdentityTypes: "read-apis/identity-types",
    cycleInfoMaster: "read-apis/cycle-info-master-2",
    getSchemeOptions: "read-apis/get-plan-option-fundmaster",
    getCountryDetails: "transactions/get-country-list",
    validateTin: "transactions/validate-tin",
    getForeignTaxIdTypes: "transactions/get-foreignTaxId-master",
  },
  getArnDetails: "read-apis/agent-details",
  getEuinDetails: "read-apis/euin-details",
  getRiaDetails: "read-apis/ria-details",
  getModeOfHolding: "read-apis/mode-of-holding-master",
  getInvertorDetails: "cloud-transaction/get-investor-details",
  portfolio: {
    detailedPortfolio: "read-apis/detailed-portfolio",
    summaryPortfolio: "read-apis/summary",
    panBasedXirr: "transactions/pan-based-xirr",
  },
  transaction: {
    transactionList: "read-apis/transaction-list",
    transactionTimeline: "read-apis/transaction-timeline",
    combinedCheckout: "cloud-transaction/combined-checkout",
    approveCombinedCheckout: "cloud-transaction/approve-combined-checkout",
    approveSwitch: "cloud-transaction/approve-switch",
    approveStp: "cloud-transaction/approve-stp",
    generate2faOtp: "cloud-transaction/generate-2fa-otp",
    trancodeDetails: "read-apis/trancode-details",
    approveAddPurchaseIsip: "cloud-transaction/approve-add-purchase-isip",
    approveAddPurchaseMandate: "cloud-transaction/approve-add-purchase-mandate",
    generatePaymentLink: "cloud-transaction/generate-payment-link",
    approveNewPurchaseMandate: "cloud-transaction/approve-new-purchase-mandate",
    approveAplNeft: "cloud-transaction/approve-apl-neft",
    approveAplRtgs: "cloud-transaction/approve-apl-rtgs",
    approveNplNeft: "cloud-transaction/approve-npl-neft",
    approveNplRtgs: "cloud-transaction/approve-npl-rtgs",

    generateOnflyMandate: "cloud-transaction/generate-onfly-mandate",
    approveNewPurchaseIsip: "cloud-transaction/approve-new-purchase-isip",
    validateVpaAddress: "cloud-transaction/validate-vpaAddress",
    uploadMinorDocument: "cloud-transaction/upload-minor-document",
    updatePaymentMode: "cloud-transaction/update-payment-mode",
    transactionSummary: "cloud-transaction/post-transaction-summary",
    transactionHistoryTimeLine: "read-apis/transaction-completion",
    upcomingNfo: "transactions/upcoming-nfo",
    getOrderDetails: "cloud-transaction/cart-order-details",
    nfoFundDetailsUrl: "fund-details/getNfoFundDetailsUrl",
    isNfo: "transactions/is-nfo",
    kycStatus: "transactions/kyc-status",
    getNewsEnhancements: "transactions/get-news-enhancements",
    clearUnits: "read-apis/clear-units",
    calculateStartDate: "transactions/calculate-start-date",
    getBrokerCode: "transactions/get-broker-code",
  },
  investorService: {
    investorServiceDetails: "read-apis/investor-service",
  },
  manageTransaction: {
    getSwitchAndStpTransactionsList: "read-apis/trtype-details",
  },
  mandates: {
    getExistingMandates: "read-apis/otm-details",
    createNewMandates: "cloud-transaction/mandate-register",
    cancelUpiMandates: "cloud-transaction/cancel-upi-mandate",
    cancelEnachMandates: "cloud-transaction/cancel-enach-mandate",
  },
  nct: {
    validateLoginNct: "nct/nct-validate-login",
    sendOtpNct: "nct/nct-send-otp",
    updateMobileNct: "nct/nct-update-mobile",
    updateEmailNct: "nct/nct-update-email",
    addBankNct: "nct/nct-add-bank",
    updateNomineNct: "nct/new-nct-update-nominee",
    sendOTPforNomineeNct: "nct/nominee-send-otp",
    resendOTPforNomineeNct: "nct/nominee-resend-otp",
    otpGenerationNct: "nct/nct-otp-generation",
    verifyOtpNct: "nct/nct-verify-otp",
    resendOtpNct: "nct/nct-resend-otp",
    newContactOtpGenerationNct: "nct/nct-new-contact-otp-generation",
    updateContactNct: "nct/nct-update-contact",
    pennyDropNct: "nct/penny-drop",
    nctAob: "nct/nct-aob",
    uploadChequeNct: "nct/upload-cheque",
    verifyOtpforNomineeNct: "nct/nominee-verify-otp",
  },
  systematicPlans: {
    productDetails: "read-apis/special-product-details",
    cancelSIPReasonsEndpoint: "cloud-transaction/sip-cancel-reasons",
    cancelSIPEndpoint: "cloud-transaction/sip-cancellation",
    cancelSWPEndpoint: "cloud-transaction/swp-cancellation",
    cancelSTPEndpoint: "cloud-transaction/stp-cancellation",
    pauseSIPEndpoint: "cloud-transaction/sip-pause",
    specialProductDetailsExtension: "read-apis/special-product-details-extension",
    approveSWPEndpoint: "cloud-transaction/approve-swp-cancellation",
    approveSTPEndpoint: "cloud-transaction/approve-stp-cancellation",
    approveSIPEndPoint: "cloud-transaction/approve-sip-cancellation",
  },
  address: {
    getAllCountries: "transactions/get-country-list",
    getStatesByCountry: "transactions/get-states",
    getCitiesByState: "transactions/get-cities",
  },
  getExitLoad: {
    exitLoad: "read-apis/exit-load",
  },
  addBankAccountNumber: {
    addBank: "cloud-transaction/verify-bank-details",
    fetchBankWithIfce: "read-apis/micrcode-details",
  },
  statements: {
    accountStatements: "statements/get-account-statement",
    completeAccountStatement: "statements/get-complete-account-statement",
    capitalGainStatement: "statements/get-captial-gain-statement",
    completeCapitalGainStatement: "statements/get-complete-captial-gain-statement",
    elssStatement: "statements/get-elss-account-statement",
    completeElssStatement: "statements/get-elss-complete-account-statement",
    statementExitLoad: "statements/get-exit-load-statement",
  },
  minorProfiles: {
    getAllMinorProfiles: "profile/minor-list-all",
    updateMinorProfile: "profile/minor-update",
    deleteMinorProfile: "profile/minor-delete",
    getDetailsOfMinorProfile: "profile/minor",
    createMinorProfile: "profile/minor-create",
  },
  jointHolderProfiles: {
    getAllJointHolderProfiles: "profile/jointholder-list-all",
    updateJointHolderProfile: "profile/jointholder-update",
    deleteJointHolderProfile: "profile/jointholder-delete",
    getDetailsOfJointHolderProfile: "profile/jointholder",
    createJointHolderProfile: "profile/jointholder-create",
  },
  instantRedemption: {
    getDetailsofInstantRedeemSchemes: "read-apis/get-insta-redeemption-details",
    validateInstantRedeem: "read-apis/insta-redeemption-validation",
    sendOTPInstantRedeem: "read-apis/insta-redeemption-send-otp",
    submitInstantRedeem: "read-apis/submit-insta-redeemption",
    statusInstantRedeem: "read-apis/insta-redeemption-status",
  },
  forceUpdate: "force-update",
};
